// import {
//   Box,
//   Button,
//   Checkbox,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   IconButton,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   TextField,
//   Typography,
//   Paper,
//   Avatar,
//   CircularProgress,
//   Tooltip
// } from "@mui/material";
// import { Close, Add } from "@material-ui/icons";
// import { useState, useMemo } from "react";
// import {
//   formatDate,
//   formatTimeAmPm,
// } from "../../../Utilities/ValidationFunctions";
// import { useSelector } from "react-redux";
// import { useUserDetailContext } from "../../../UserDetailContext";
// import { useDispatch } from "react-redux";
// import { getAllEvents, getFeeds, getInvaiteUsersEvent, getMyEvents, getMyFeeds, getRegisteredAttendees, RegisterEvent } from "../../../../Redux/Reducers/communityReducer";
// import {
//   getSingleEvent,
//   getAttendeeAccessPass,
// } from "../../../../Redux/Reducers/communityReducer";
// import TicketCard from "./TicketCard";
// import CloseIcon from "@mui/icons-material/Close";
// import { useQuantityContext } from "../../../QuantityContext";
// import { getGlobleUsers } from "../../../../Redux/Reducers/ContactReducer";

// const TicketBookingModal = ({ open, onClose, event }) => {
//   console.log("event+++", event)
//   const [showContactsModal, setShowContactsModal] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedContacts, setSelectedContacts] = useState([]);
//   const [tempSelectedContacts, setTempSelectedContacts] = useState([]); // For modal selections
//   const { userDetails } = useUserDetailContext();
//   const [showTicketCard, setShowTicketCard] = useState(false);
//   const [isRegistering, setIsRegistering] = useState(false);
//   const { openSnackbar } = useQuantityContext();
//   const dispatch = useDispatch();
//   const singleEvent = useSelector((state) => state.community.singleEvent);
//   const exploreType = useSelector((state) => state?.community?.exploreType);
//    const globalusersData = useSelector(state => state.ContactArray?.globalusersData?.data) || [];
//   const getInviteUserEvent = useSelector((state) => state.community.getInviteUserEvent);
//   console.log("getInviteUserEvent+++", getInviteUserEvent)

//   console.log("globalusersDataNN", globalusersData)

//   const MAX_SELECTION = 10;
//   console.log("singleEvent xcds", singleEvent)

//   const professionalData = useSelector(
//     (state) => state.ProfileArray.professionaProfile
//   );
//   const connectedContacts = useSelector(
//     (state) => state.ContactArray.ConnectedContact
//   );

//   const interviewers = useSelector((state) => {
//     const interviewersData = state?.jobs?.interviewers?.interviewers;
//     return Array.isArray(interviewersData) ? interviewersData : [];
//   }) || [];

//   // Create a Set of invited user IDs for O(1) lookup
//   const invitedUserIds = useMemo(() => {
//     if (getInviteUserEvent) {
//       return new Set(getInviteUserEvent.map(invitee => invitee.invited_user_id));
//     }
//     return new Set();
//   }, [getInviteUserEvent]);

//   // Check if a contact is invited
//   const isContactInvited = (contact) => {
//     return invitedUserIds.has(contact.reference_id);
//   };

//   const isContactSelected = (contact, selectionList = selectedContacts) =>
//     selectionList.some((c) => c.reference_id == contact.reference_id);

//   const removeContact = (reference_id) => {
//     setSelectedContacts((prev) => prev.filter((c) => c.reference_id !== reference_id));
//   };

//   // Check if any selected contact is not invited
//   const hasUninvitedAttendees = useMemo(() => {
//     return selectedContacts.some(contact => !isContactInvited(contact));
//   }, [selectedContacts]);

//   const filteredContacts = (interviewers || []).filter(
//     (contact) =>
//       contact &&
//       typeof contact === 'object' &&
//       // Exclude current user from contacts list
//       contact.reference_id !== userDetails?.reference_id
//   ).filter((contact) =>
//     `${contact.first_name || ''} ${contact.last_name || ''} ${contact.email || ''}`
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   console.log("filteredContacts852", filteredContacts)
//   console.log("invitedUserIds", invitedUserIds)
//   console.log("hasUninvitedAttendees", hasUninvitedAttendees)

//   const handleRegister = async () => {
//     // Check for uninvited attendees before registration
//     if (hasUninvitedAttendees) {
//       openSnackbar("Cannot register: Some selected attendees are not invited to this event", "error", 4000);
//       return;
//     }

//     if (event?.attendees_limit === 0) {
//       openSnackbar(`No more slots are available for this event`, "error", 4000);
//       return;
//     }

//     setIsRegistering(true);
//     const attendees = [
//       userDetails?.reference_id,
//       ...selectedContacts.map((c) => c.reference_id),
//     ];

//     const payload = {
//       attendees,
//       eventId: event.id,
//     };

//     try {
//       const res = await dispatch(RegisterEvent(payload)).unwrap();

//       // Only fetch ticket if registration is successful
//       if (res?.statusCode === 201 || res?.statusCode === 200) {
//         const updatedEventRes = await dispatch(getSingleEvent(event.id)).unwrap();
//         const ticketId = updatedEventRes?.data?.registration?.ticket_id;

//         // Only fetch access pass if ticket ID is available
//         if (ticketId) {
//           await dispatch(getAttendeeAccessPass(ticketId));
//           await dispatch(getFeeds(payload));
//           await dispatch(getMyFeeds({ type: exploreType }));
//           await dispatch(getMyEvents({ page: 0, my_events: true, type: exploreType }));
//           await dispatch(getAllEvents({ page: 0, my_events: false, type: exploreType }));
//           openSnackbar("Access pass created successfully", "success", 4000);
//           setShowTicketCard(true);
//           await dispatch(getRegisteredAttendees({ type: exploreType }));
//           onClose();
//         }
//       }
//     } catch (error) {
//       console.error("Registration error:", error);
//       openSnackbar(`Registration Failed. Only ${event?.attendees_limit} slots remaining.`, "error", 4000);
//     } finally {
//       setIsRegistering(false); // Stop loading regardless of success/error
//     }
//   };

//   const handleCloseTicketCard = () => {
//     setShowTicketCard(false);
//   };

//   // Modal specific functions
//   const handleOpenContactsModal = async () => {
//     const params = {
//       searchParam: "a",
//       limit: 20,
//       offsetValue: 1,
//     }
//     await dispatch(getGlobleUsers(params))
//     setTempSelectedContacts(selectedContacts); // Initialize with currently selected contacts
//     setSearchTerm(""); // Reset search
//     setShowContactsModal(true);
//   };

//   const handleCloseContactsModal = () => {
//     setShowContactsModal(false);
//     setTempSelectedContacts([]); // Clear temp selections
//     setSearchTerm(""); // Reset search
//   };

//   const handleAddSelectedContacts = () => {
//     setSelectedContacts(tempSelectedContacts);
//     handleCloseContactsModal();
//   };

//   const isTempContactSelected = (contact) =>
//     tempSelectedContacts.some((c) => c.reference_id == contact.reference_id);

//   const handleTempSelectAll = () => {
//     // Only select invited contacts
//     const selectableContacts = filteredContacts.filter(contact =>
//       isContactInvited(contact) && !isTempContactSelected(contact)
//     );

//     const remainingSlots = MAX_SELECTION - tempSelectedContacts.length;
//     const toAdd = selectableContacts.slice(0, remainingSlots);
//     setTempSelectedContacts((prev) => [...prev, ...toAdd]);

//     // Show warning if there are non-invited contacts that couldn't be selected
//     const nonInvitedCount = filteredContacts.filter(contact =>
//       !isContactInvited(contact) && !isTempContactSelected(contact)
//     ).length;

//     if (nonInvitedCount > 0) {
//       openSnackbar(`${nonInvitedCount} contact(s) cannot be selected as they are not invited to this event`, "warning", 4000);
//     }
//   };

//   const handleTempDeselectAll = () => {
//     // Remove only those currently visible in filteredContacts
//     setTempSelectedContacts((prev) =>
//       prev.filter(
//         (c) => !filteredContacts.some((fc) => fc.reference_id === c.reference_id)
//       )
//     );
//   };

//   const toggleTempContactSelection = (contact) => {
//     // Check if contact is invited before allowing selection
//     if (!isContactInvited(contact) && !isTempContactSelected(contact)) {
//       openSnackbar("This contact is not invited to this event", "warning", 4000);
//       return;
//     }

//     setTempSelectedContacts((prev) => {
//       const alreadySelected = prev.some((c) => c.reference_id === contact.reference_id);
//       if (alreadySelected) {
//         return prev.filter((c) => c.reference_id !== contact.reference_id);
//       } else if (prev.length < MAX_SELECTION) {
//         return [...prev, contact];
//       } else {
//         openSnackbar(`Maximum ${MAX_SELECTION} attendees can be selected`, "warning", 4000);
//         return prev; // Do not add more than 10
//       }
//     });
//   };

//   const formatDate = (date) => {
//     return new Date(date).toLocaleDateString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });
//   };

//   const formatTime = (date) => {
//     return new Date(date).toLocaleTimeString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2 } }}
//       >
//         <DialogTitle sx={{ py: 2, px: 3 }}>
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//           >
//             <Typography variant="h5" fontWeight="bold">
//               Book Ticket
//             </Typography>
//             <IconButton onClick={onClose} sx={{ color: "black" }}>
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         <DialogContent sx={{ p: 3, pt: 0 }}>
//           {/* Event Details */}
//           <Box sx={{ mb: 3 }}>
//             <Typography variant="h6" fontWeight="bold" gutterBottom>
//               {event.title}
//             </Typography>
//             <Typography variant="body1" gutterBottom>
//               {formatDate(event.start_time)} •{" "}
//               {formatTime(event.start_time)} - {formatTime(event.end_time)}
//             </Typography>
//             {event.mode === "Offline" && event.event_location && (
//               <Typography variant="body2" color="text.secondary">
//                 {event.event_location}
//               </Typography>
//             )}
//             {/* Show event type badge for public events */}
//             {event.event_access_level === "Public" && (
//               <Typography
//                 variant="caption"
//                 sx={{
//                   display: 'inline-block',
//                   mt: 1,
//                   px: 1,
//                   py: 0.5,
//                   bgcolor: '#e3f2fd',
//                   borderRadius: 1,
//                   color: '#0044C6'
//                 }}
//               >
//                 Public Event
//               </Typography>
//             )}
//           </Box>

//           <Divider sx={{ my: 2 }} />

//           {/* Primary Attendee Card */}
//           <Typography variant="h6" fontWeight="bold" gutterBottom>
//             Primary Attendee Information
//           </Typography>
//           <Paper
//             elevation={0}
//             sx={{
//               p: 2,
//               mb: 3,
//               borderRadius: 1,
//               border: "1px solid #E0E0E0",
//               bgcolor: "background.paper",
//             }}
//           >
//             <TextField
//               fullWidth
//               variant="outlined"
//               label="Name"
//               value={`${userDetails?.firstName} ${userDetails?.lastName}`}
//               disabled
//               sx={{ mb: 2 }}
//               InputProps={{
//                 sx: {
//                   color: "black",
//                   "&.Mui-disabled": {
//                     color: "black",
//                     backgroundColor: "#F9F9F9",
//                   },
//                 },
//               }}
//             />
//             <TextField
//               fullWidth
//               variant="outlined"
//               label="Email"
//               value={professionalData?.professional_email}
//               disabled
//               sx={{ mb: 2 }}
//               InputProps={{
//                 sx: {
//                   color: "black",
//                   "&.Mui-disabled": {
//                     color: "black",
//                     backgroundColor: "#F9F9F9",
//                   },
//                 },
//               }}
//             />
//             <TextField
//               fullWidth
//               variant="outlined"
//               label="Phone"
//               value={professionalData?.phone_no}
//               disabled
//               InputProps={{
//                 sx: {
//                   color: "black",
//                   "&.Mui-disabled": {
//                     color: "black",
//                     backgroundColor: "#F9F9F9",
//                   },
//                 },
//               }}
//             />
//           </Paper>

//           <Divider sx={{ my: 2 }} />

//           {/* Additional Attendees Section - Now visible for all event types */}
//           <Box sx={{ mb: 2 }}>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//               mb={1}
//             >
//               <Typography variant="h6" fontWeight="bold">
//                 Additional Attendees
//                 <Typography component="span" variant="caption" sx={{ ml: 1, color: '#0044C6' }}>
//                   (Invited users only)
//                 </Typography>
//               </Typography>
//               <Tooltip title="Add invited attendees">
//                 <IconButton
//                   onClick={handleOpenContactsModal}
//                   sx={{
//                     bgcolor: "#0044C6",
//                     color: "white",
//                     "&:hover": { bgcolor: "#0034A3" },
//                   }}
//                 >
//                   <Add />
//                 </IconButton>
//               </Tooltip>
//             </Box>

//             <Typography variant="body2" color="textSecondary" mb={2}>
//               You can add additional attendee(s) who are invited to this event
//             </Typography>

//             {/* Show warning if there are uninvited attendees */}
//             {hasUninvitedAttendees && (
//               <Paper
//                 sx={{
//                   p: 2,
//                   mb: 2,
//                   bgcolor: '#fff3e0',
//                   border: '1px solid #ffb74d',
//                   borderRadius: 1
//                 }}
//               >
//                 <Typography variant="body2" color="#e65100">
//                   ⚠️ Some selected attendees are not invited to this event. Please remove them to register.
//                 </Typography>
//               </Paper>
//             )}

//             {selectedContacts?.length > 0 ? (
//               selectedContacts?.map((contact, index) => {
//                 const isInvited = isContactInvited(contact);
//                 return (
//                   <Paper
//                     key={contact?.reference_id}
//                     elevation={0}
//                     sx={{
//                       p: 2,
//                       mb: 2,
//                       borderRadius: 1,
//                       border: "1px solid #E0E0E0",
//                       position: "relative",
//                       bgcolor: "background.paper",
//                       ...(!isInvited && {
//                         borderColor: '#ff9800',
//                         bgcolor: '#fff3e0'
//                       })
//                     }}
//                   >
//                     {/* REMOVE BUTTON - VISIBLE AT TOP RIGHT */}
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         paddingBottom: 1,
//                       }}
//                     >
//                       <Typography>
//                         Attendee {index + 2}
//                         {!isInvited && (
//                           <Typography component="span" variant="caption" sx={{ ml: 1, color: '#e65100' }}>
//                             (Not Invited)
//                           </Typography>
//                         )}
//                       </Typography>
//                       <IconButton
//                         size="small"
//                         aria-label="remove attendee"
//                         onClick={() => removeContact(contact?.reference_id)}
//                         sx={{
//                           position: "absolute",
//                           top: 8,
//                           right: 8,
//                           color: "rgba(0, 0, 0, 0.6)",
//                           "&:hover": {
//                             backgroundColor: "rgba(0, 0, 0, 0.05)",
//                           },
//                         }}
//                       >
//                         <Close fontSize="small" />
//                       </IconButton>
//                     </Box>

//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       label="Name"
//                       value={`${contact.first_name} ${contact.last_name || ""}`}
//                       disabled
//                       sx={{ mb: 2 }}
//                       InputProps={{
//                         sx: {
//                           color: "black",
//                           "&.Mui-disabled": {
//                             color: "black",
//                             backgroundColor: "#F9F9F9",
//                           },
//                         },
//                       }}
//                     />
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       label="Email"
//                       value={contact.email}
//                       disabled
//                       sx={{ mb: 2 }}
//                       InputProps={{
//                         sx: {
//                           color: "black",
//                           "&.Mui-disabled": {
//                             color: "black",
//                             backgroundColor: "#F9F9F9",
//                           },
//                         },
//                       }}
//                     />
//                     <TextField
//                       fullWidth
//                       variant="outlined"
//                       label="Phone"
//                       value={contact.phone_no}
//                       disabled
//                       InputProps={{
//                         sx: {
//                           color: "black",
//                           "&.Mui-disabled": {
//                             color: "black",
//                             backgroundColor: "#F9F9F9",
//                           },
//                         },
//                       }}
//                     />
//                   </Paper>
//                 );
//               })
//             ) : (
//               <Typography
//                 variant="body2"
//                 color="textSecondary"
//                 align="center"
//                 mb={2}
//                 sx={{ py: 2 }}
//               >
//                 No additional attendees added.
//               </Typography>
//             )}

//             <Typography
//               variant="body2"
//               color="textSecondary"
//               fontStyle="italic"
//               mt={1}
//             >
//               Note: You cannot transfer or cancel a ticket that you own.
//             </Typography>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ p: 3, pt: 0 }}>
//           <Button
//             fullWidth
//             variant="contained"
//             size="large"
//             disabled={isRegistering || hasUninvitedAttendees}
//             sx={{
//               bgcolor: "#0044C6",
//               color: "white",
//               py: 1.5,
//               fontWeight: "bold",
//               borderRadius: 1,
//               "&:hover": { bgcolor: "#0034A3" },
//               "&.Mui-disabled": {
//                 bgcolor: "#e0e0e0",
//                 color: "#a0a0a0"
//               }
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleRegister();
//             }}
//           >
//             {isRegistering ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               hasUninvitedAttendees ? "Remove Uninvited Attendees" : "Register"
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* TicketCard Modal */}
//       <Dialog
//         open={showTicketCard}
//         onClose={handleCloseTicketCard}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             background: "rgba(255,255,255,0.1)",
//             backdropFilter: "blur(16px)",
//             boxShadow: 24,
//             borderRadius: 2,
//             p: 0,
//             minHeight: "80vh",
//             width: "30%",
//             scrollbarWidth: "none",
//             position: "relative",
//           },
//           elevation: 0,
//         }}
//         sx={{
//           "& .MuiDialog-container": {
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             backdropFilter: "blur(8px)",
//             background: "rgba(0,0,0,0.3)",
//           },
//         }}
//       >
//         <Box
//           sx={{ position: "relative", width: "100%", p: 0 }}
//           onClick={e => e.stopPropagation()}
//         >
//           <IconButton
//             aria-label="close"
//             onClick={handleCloseTicketCard}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//               zIndex: 10,
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <Box sx={{ display: "flex", justifyContent: "center", p: 0 }}>
//             <TicketCard event={event} onClose={handleCloseTicketCard} />
//           </Box>
//         </Box>
//       </Dialog>

//       {/* Contacts Selection Modal */}
//       <Dialog
//         open={showContactsModal}
//         onClose={handleCloseContactsModal}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 2, maxHeight: "80vh" } }}
//       >
//         <DialogTitle sx={{ py: 2, px: 3 }}>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6" fontWeight="bold">
//               Select Attendees
//               <Typography component="span" variant="caption" sx={{ ml: 1, color: '#0044C6', display: 'block' }}>
//                 Only invited users can be selected
//               </Typography>
//             </Typography>
//             <IconButton onClick={handleCloseContactsModal}>
//               <Close />
//             </IconButton>
//           </Box>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Search contacts..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             sx={{ mt: 2 }}
//           />
//           <Box display="flex" alignItems="center" mt={2}>
//             <Button
//               size="small"
//               variant="outlined"
//               onClick={handleTempSelectAll}
//               disabled={
//                 tempSelectedContacts.length >= MAX_SELECTION ||
//                 filteredContacts.length === 0
//               }
//               sx={{ mr: 1 }}
//             >
//               Select All (max {MAX_SELECTION})
//             </Button>
//             <Button
//               size="small"
//               variant="outlined"
//               onClick={handleTempDeselectAll}
//               disabled={tempSelectedContacts.length === 0}
//             >
//               Deselect All
//             </Button>
//             <Typography variant="caption" sx={{ ml: 2 }}>
//               {tempSelectedContacts.length}/{MAX_SELECTION} selected
//             </Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: 0 }}>
//           <List sx={{ pt: 0 }}>
//             {filteredContacts?.map((contact) => {
//               const isInvited = isContactInvited(contact);
//               const isSelected = isTempContactSelected(contact);
//               const isDisabled = !isSelected && (
//                 tempSelectedContacts.length >= MAX_SELECTION ||
//                 !isInvited
//               );

//               return (
//                 <ListItem
//                   key={contact.reference_id}
//                   button
//                   onClick={() => toggleTempContactSelection(contact)}
//                   disabled={isDisabled}
//                   sx={{
//                     "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
//                     ...(!isInvited && {
//                       opacity: 0.7,
//                       backgroundColor: '#f5f5f5'
//                     })
//                   }}
//                 >
//                   <ListItemIcon>
//                     <Checkbox
//                       edge="start"
//                       checked={isSelected}
//                       tabIndex={-1}
//                       disableRipple
//                       color="primary"
//                       disabled={isDisabled}
//                     />
//                   </ListItemIcon>
//                   <Avatar
//                     src={contact.profile_url}
//                     alt={`${contact.first_name} ${contact.last_name || ""}`}
//                     sx={{ mr: 2 }}
//                   />
//                   <ListItemText
//                     primary={
//                       <span>
//                         {contact.first_name} {contact.last_name || ""}
//                         <span style={{ color: "#888", fontSize: 12, marginLeft: 8 }}>
//                           {contact.role_title}
//                         </span>
//                         {!isInvited && (
//                           <span style={{ color: "#ff9800", fontSize: 12, marginLeft: 8 }}>
//                             (Not Invited)
//                           </span>
//                         )}
//                       </span>
//                     }
//                     secondary={
//                       (() => {
//                         const email = contact?.email;
//                         const phone = contact?.phone_no;
//                         if (email && phone) {
//                           return (
//                             <>
//                               <span>{email}</span>
//                               <span style={{ marginLeft: 8 }}>{phone}</span>
//                             </>
//                           );
//                         }
//                         if (email) return <span>{email}</span>;
//                         if (phone) return <span>{phone}</span>;
//                         return <span>No contact info</span>;
//                       })()
//                     }
//                     primaryTypographyProps={{ style: { color: "black" } }}
//                     secondaryTypographyProps={{ style: { color: "gray" } }}
//                   />
//                 </ListItem>
//               );
//             })}
//           </List>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button
//             onClick={handleCloseContactsModal}
//             sx={{ color: "#0044C6" }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleAddSelectedContacts}
//             sx={{
//               bgcolor: "#0044C6",
//               color: "white",
//               "&:hover": { bgcolor: "#0034A3" },
//               borderRadius: 1,
//             }}
//           >
//             Add Selected ({tempSelectedContacts.length})
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default TicketBookingModal;

import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
  Paper,
  Avatar,
  CircularProgress,
  Tooltip
} from "@mui/material";
import { Close, Add } from "@material-ui/icons";
import { useState, useMemo, useCallback } from "react";
import {
  formatDate,
  formatTimeAmPm,
} from "../../../Utilities/ValidationFunctions";
import { useSelector } from "react-redux";
import { useUserDetailContext } from "../../../UserDetailContext";
import { useDispatch } from "react-redux";
import { getAllEvents, getFeeds, getMyEvents, getMyFeeds, getRegisteredAttendees, RegisterEvent } from "../../../../Redux/Reducers/communityReducer";
import {
  getSingleEvent,
  getAttendeeAccessPass,
} from "../../../../Redux/Reducers/communityReducer";
import TicketCard from "./TicketCard";
import CloseIcon from "@mui/icons-material/Close";
import { useQuantityContext } from "../../../QuantityContext";
import { getGlobleUsers } from "../../../../Redux/Reducers/ContactReducer";
import debounce from "lodash/debounce";

const TicketBookingModal = ({ open, onClose, event }) => {
  // console.log("event+++", event)
  const [showContactsModal, setShowContactsModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [tempSelectedContacts, setTempSelectedContacts] = useState([]); // For modal selections
  const { userDetails } = useUserDetailContext();
  const [showTicketCard, setShowTicketCard] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const { openSnackbar } = useQuantityContext();
  const dispatch = useDispatch();
  const singleEvent = useSelector((state) => state.community.singleEvent);
  const exploreType = useSelector((state) => state?.community?.exploreType);
  const globalusersData = useSelector(state => state.ContactArray?.globalusersData?.data) || [];

  // console.log("globalusersDataNN", globalusersData)

  const MAX_SELECTION = 10;
  // console.log("singleEvent xcds", singleEvent)

  const professionalData = useSelector(
    (state) => state.ProfileArray.professionaProfile
  );

  // Filter contacts from globalusersData
  const filteredContacts = (globalusersData || []).filter(
    (contact) =>
      contact &&
      typeof contact === 'object' &&
      // Exclude current user from contacts list
      contact.reference_id !== userDetails?.reference_id
  ).filter((contact) =>
    `${contact.first_name || ''} ${contact.last_name || ''} ${contact.email || ''} ${contact.phone_no || ''}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // console.log("filteredContacts", filteredContacts)

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(async (searchValue) => {
      const params = {
        searchParam: searchValue.trim() === "" ? "a" : searchValue,
        limit: 20,
        offsetValue: 1,
      };
      await dispatch(getGlobleUsers(params));
      setIsSearching(false);
    }, 500),
    [dispatch]
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsSearching(true);
    debouncedSearch(value);
  };

  const isContactSelected = (contact, selectionList = selectedContacts) =>
    selectionList.some((c) => c.reference_id == contact.reference_id);

  const removeContact = (reference_id) => {
    setSelectedContacts((prev) => prev.filter((c) => c.reference_id !== reference_id));
  };

  const handleRegister = async () => {
    if (event?.attendees_limit === 0) {
      openSnackbar(`No more slots are available for this event`, "error", 4000);
      return;
    }

    setIsRegistering(true);
    const attendees = [
      userDetails?.reference_id,
      ...selectedContacts.map((c) => c.reference_id),
    ];

    const payload = {
      attendees,
      eventId: event.id,
    };

    try {
      const res = await dispatch(RegisterEvent(payload)).unwrap();
      // Only fetch ticket if registration is successful
      if (res?.data?.statusCode === 201 || res?.data?.statusCode === 200) {
        const updatedEventRes = await dispatch(getSingleEvent(event.id)).unwrap();
        const ticketId = updatedEventRes?.data?.registration?.ticket_id;

        // Only fetch access pass if ticket ID is available
        if (ticketId) {
          await dispatch(getAttendeeAccessPass(ticketId));
          await dispatch(getFeeds(payload));
          await dispatch(getMyFeeds({ type: exploreType }));
          await dispatch(getMyEvents({ page: 0, my_events: true, type: exploreType }));
          await dispatch(getAllEvents({ page: 0, my_events: false, type: exploreType }));
          openSnackbar("Access pass created successfully", "success", 4000);
          setShowTicketCard(true);
          await dispatch(getRegisteredAttendees({ type: exploreType }));
          onClose();
        }
      }
    } catch (res) {
      openSnackbar(res, "error", 4000);
    } finally {
      setIsRegistering(false); // Stop loading regardless of success/error
    }
  };

  const handleCloseTicketCard = () => {
    setShowTicketCard(false);
  };

  // Modal specific functions
  const handleOpenContactsModal = async () => {
    setSearchTerm("");
    setIsSearching(true);
    const params = {
      searchParam: "a",
      limit: 20,
      offsetValue: 1,
    }
    await dispatch(getGlobleUsers(params));
    setIsSearching(false);
    setTempSelectedContacts(selectedContacts); // Initialize with currently selected contacts
    setShowContactsModal(true);
  };

  const handleCloseContactsModal = () => {
    setShowContactsModal(false);
    setTempSelectedContacts([]); // Clear temp selections
    setSearchTerm(""); // Reset search
  };

  const handleAddSelectedContacts = () => {
    setSelectedContacts(tempSelectedContacts);
    handleCloseContactsModal();
  };

  const isTempContactSelected = (contact) =>
    tempSelectedContacts.some((c) => c.reference_id == contact.reference_id);

  const handleTempSelectAll = () => {
    const selectableContacts = filteredContacts.filter(contact =>
      !isTempContactSelected(contact)
    );

    const remainingSlots = MAX_SELECTION - tempSelectedContacts.length;
    const toAdd = selectableContacts.slice(0, remainingSlots);
    setTempSelectedContacts((prev) => [...prev, ...toAdd]);
  };

  const handleTempDeselectAll = () => {
    // Remove only those currently visible in filteredContacts
    setTempSelectedContacts((prev) =>
      prev.filter(
        (c) => !filteredContacts.some((fc) => fc.reference_id === c.reference_id)
      )
    );
  };

  const toggleTempContactSelection = (contact) => {
    setTempSelectedContacts((prev) => {
      const alreadySelected = prev.some((c) => c.reference_id === contact.reference_id);
      if (alreadySelected) {
        return prev.filter((c) => c.reference_id !== contact.reference_id);
      } else if (prev.length < MAX_SELECTION) {
        return [...prev, contact];
      } else {
        openSnackbar(`Maximum ${MAX_SELECTION} attendees can be selected`, "warning", 4000);
        return prev; // Do not add more than 10
      }
    });
  };

  const formatDateDisplay = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ py: 2, px: 3 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" fontWeight="bold">
              Book Ticket
            </Typography>
            <IconButton onClick={onClose} sx={{ color: "black" }}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3, pt: 0 }}>
          {/* Event Details */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {event.title}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {formatDateDisplay(event.start_time)} •{" "}
              {formatTime(event.start_time)} - {formatTime(event.end_time)}
            </Typography>
            {event.mode === "Offline" && event.event_location && (
              <Typography variant="body2" color="text.secondary">
                {event.event_location}
              </Typography>
            )}
            {/* Show event type badge for public events */}
            {event.event_access_level === "Public" && (
              <Typography
                variant="caption"
                sx={{
                  display: 'inline-block',
                  mt: 1,
                  px: 1,
                  py: 0.5,
                  bgcolor: '#e3f2fd',
                  borderRadius: 1,
                  color: '#0044C6'
                }}
              >
                Public Event
              </Typography>
            )}
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Primary Attendee Card */}
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Primary Attendee Information
          </Typography>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 3,
              borderRadius: 1,
              border: "1px solid #E0E0E0",
              bgcolor: "background.paper",
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              label="Name"
              value={`${userDetails?.firstName} ${userDetails?.lastName}`}
              disabled
              sx={{ mb: 2 }}
              InputProps={{
                sx: {
                  color: "black",
                  "&.Mui-disabled": {
                    color: "black",
                    backgroundColor: "#F9F9F9",
                  },
                },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              label="Email"
              value={professionalData?.professional_email}
              disabled
              sx={{ mb: 2 }}
              InputProps={{
                sx: {
                  color: "black",
                  "&.Mui-disabled": {
                    color: "black",
                    backgroundColor: "#F9F9F9",
                  },
                },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              label="Phone"
              value={professionalData?.phone_no}
              disabled
              InputProps={{
                sx: {
                  color: "black",
                  "&.Mui-disabled": {
                    color: "black",
                    backgroundColor: "#F9F9F9",
                  },
                },
              }}
            />
          </Paper>

          <Divider sx={{ my: 2 }} />

          {/* Additional Attendees Section */}
          <Box sx={{ mb: 2 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Typography variant="h6" fontWeight="bold">
                Additional Attendees
              </Typography>
              <Tooltip title="Add attendees">
                <IconButton
                  onClick={handleOpenContactsModal}
                  sx={{
                    bgcolor: "#0044C6",
                    color: "white",
                    "&:hover": { bgcolor: "#0034A3" },
                  }}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            </Box>

            <Typography variant="body2" color="textSecondary" mb={2}>
              You can add additional attendee(s) to this event
            </Typography>

            {selectedContacts?.length > 0 ? (
              selectedContacts?.map((contact, index) => {
                return (
                  <Paper
                    key={contact?.reference_id}
                    elevation={0}
                    sx={{
                      p: 2,
                      mb: 2,
                      borderRadius: 1,
                      border: "1px solid #E0E0E0",
                      position: "relative",
                      bgcolor: "background.paper",
                    }}
                  >
                    {/* REMOVE BUTTON - VISIBLE AT TOP RIGHT */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingBottom: 1,
                      }}
                    >
                      <Typography>
                        Attendee {index + 2}
                      </Typography>
                      <IconButton
                        size="small"
                        aria-label="remove attendee"
                        onClick={() => removeContact(contact?.reference_id)}
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          color: "rgba(0, 0, 0, 0.6)",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                          },
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>

                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Name"
                      value={`${contact.first_name} ${contact.last_name || ""}`}
                      disabled
                      sx={{ mb: 2 }}
                      InputProps={{
                        sx: {
                          color: "black",
                          "&.Mui-disabled": {
                            color: "black",
                            backgroundColor: "#F9F9F9",
                          },
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Email"
                      value={contact.email}
                      disabled
                      sx={{ mb: 2 }}
                      InputProps={{
                        sx: {
                          color: "black",
                          "&.Mui-disabled": {
                            color: "black",
                            backgroundColor: "#F9F9F9",
                          },
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Phone"
                      value={contact.phone_no}
                      disabled
                      InputProps={{
                        sx: {
                          color: "black",
                          "&.Mui-disabled": {
                            color: "black",
                            backgroundColor: "#F9F9F9",
                          },
                        },
                      }}
                    />
                  </Paper>
                );
              })
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                align="center"
                mb={2}
                sx={{ py: 2 }}
              >
                No additional attendees added.
              </Typography>
            )}

            <Typography
              variant="body2"
              color="textSecondary"
              fontStyle="italic"
              mt={1}
            >
              Note: You cannot transfer or cancel a ticket that you own.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            disabled={isRegistering}
            sx={{
              bgcolor: "#0044C6",
              color: "white",
              py: 1.5,
              fontWeight: "bold",
              borderRadius: 1,
              "&:hover": { bgcolor: "#0034A3" },
              "&.Mui-disabled": {
                bgcolor: "#e0e0e0",
                color: "#a0a0a0"
              }
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleRegister();
            }}
          >
            {isRegistering ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Register"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* TicketCard Modal */}
      <Dialog
        open={showTicketCard}
        onClose={handleCloseTicketCard}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            background: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(16px)",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
            minHeight: "80vh",
            width: "30%",
            scrollbarWidth: "none",
            position: "relative",
          },
          elevation: 0,
        }}
        sx={{
          "& .MuiDialog-container": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(8px)",
            background: "rgba(0,0,0,0.3)",
          },
        }}
      >
        <Box
          sx={{ position: "relative", width: "100%", p: 0 }}
          onClick={e => e.stopPropagation()}
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseTicketCard}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: "flex", justifyContent: "center", p: 0 }}>
            <TicketCard event={event} onClose={handleCloseTicketCard} />
          </Box>
        </Box>
      </Dialog>

      {/* Contacts Selection Modal */}
      <Dialog
        open={showContactsModal}
        onClose={handleCloseContactsModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, maxHeight: "80vh" } }}
      >
        <DialogTitle sx={{ py: 2, px: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" fontWeight="bold">
              Select Attendees
            </Typography>
            <IconButton onClick={handleCloseContactsModal}>
              <Close />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search users by name, email or phone..."
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ mt: 2 }}
            InputProps={{
              endAdornment: isSearching && (
                <CircularProgress size={20} />
              ),
            }}
          />
          <Box display="flex" alignItems="center" mt={2}>
            <Button
              size="small"
              variant="outlined"
              onClick={handleTempSelectAll}
              disabled={
                tempSelectedContacts.length >= MAX_SELECTION ||
                filteredContacts.length === 0
              }
              sx={{ mr: 1 }}
            >
              Select All (max {MAX_SELECTION})
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={handleTempDeselectAll}
              disabled={tempSelectedContacts.length === 0}
            >
              Deselect All
            </Button>
            <Typography variant="caption" sx={{ ml: 2 }}>
              {tempSelectedContacts.length}/{MAX_SELECTION} selected
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <List sx={{ pt: 0 }}>
            {filteredContacts?.length > 0 ? (
              filteredContacts?.map((contact) => {
                const isSelected = isTempContactSelected(contact);
                const isDisabled = !isSelected && tempSelectedContacts.length >= MAX_SELECTION;

                return (
                  <ListItem
                    key={contact.reference_id}
                    button
                    onClick={() => toggleTempContactSelection(contact)}
                    disabled={isDisabled}
                    sx={{
                      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={isSelected}
                        tabIndex={-1}
                        disableRipple
                        color="primary"
                        disabled={isDisabled}
                      />
                    </ListItemIcon>
                    <Avatar
                      src={contact.profile_url}
                      alt={`${contact.first_name} ${contact.last_name || ""}`}
                      sx={{ mr: 2 }}
                    />
                    <ListItemText
                      primary={
                        <span>
                          {contact.first_name} {contact.last_name || ""}
                          <span style={{ color: "#888", fontSize: 12, marginLeft: 8 }}>
                            {contact.title || contact.designation || ""}
                          </span>
                        </span>
                      }
                      secondary={
                        (() => {
                          const email = contact?.email;
                          const phone = contact?.phone_no;
                          if (email && phone) {
                            return (
                              <>
                                <span>{email}</span>
                                <span style={{ marginLeft: 8 }}>{phone}</span>
                              </>
                            );
                          }
                          if (email) return <span>{email}</span>;
                          if (phone) return <span>{phone}</span>;
                          return <span>No contact info</span>;
                        })()
                      }
                      primaryTypographyProps={{ style: { color: "black" } }}
                      secondaryTypographyProps={{ style: { color: "gray" } }}
                    />
                  </ListItem>
                );
              })
            ) : (
              <ListItem>
                <Typography variant="body2" color="textSecondary" sx={{ textAlign: "center", width: "100%", py: 2 }}>
                  {searchTerm ? "No users found" : "Start typing to search users"}
                </Typography>
              </ListItem>
            )}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseContactsModal}
            sx={{ color: "#0044C6" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddSelectedContacts}
            sx={{
              bgcolor: "#0044C6",
              color: "white",
              "&:hover": { bgcolor: "#0034A3" },
              borderRadius: 1,
            }}
          >
            Add Selected ({tempSelectedContacts.length})
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TicketBookingModal;